import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { ChevronDoubleLeftIcon,  ChevronDoubleRightIcon } from "@heroicons/react/24/outline";
import NavButtonsSection from "./components/navButtonsSection";
import Logo from "../../fronteraLogo.png";

import EllipseIcon from "../../assets/icons/ellipse23.svg";
import CodiBubbler from "../codiBubbler/codiBubbler";
// import CodiButton from "../../assets/icons/CodiButton.svg";
// import CodiButtonHover from "../../assets/icons/CodiButtonHover.svg";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NavBar = ({ collapsed, setCollapsed }) => {
  const { username: urlUsername } = useParams();
  const location = useLocation();
  const currentUsername = localStorage.getItem("username");
  const username = currentUsername || urlUsername;

  const [showCodiHint, setShowCodiHint] = useState(false);

  const navigate = useNavigate();
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  const shouldShowFloatingToggle = location.pathname.includes("/messages");

  useEffect(() => {
    const fetchUnreadMessages = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await fetch(`${BACKEND_URL}/chats`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();
        const email = localStorage.getItem("userEmail");
        if (res.ok && data.chats) {
          let total = 0;
          for (const chat of data.chats) {
            const participants = chat.participants || [];
            if (
              participants.includes(email) &&
              chat.lastSender !== email &&
              chat.unreadCount > 0
            ) {
              total += chat.unreadCount;
            }
          }
          setUnreadMessagesCount(total);
        }
      } catch (e) {
        console.error("❌ Error fetching unread messages", e);
      }
    };

    fetchUnreadMessages();
  }, []);

  useEffect(() => {
    // show only once when sidebar opens
    if (!collapsed) {
      setShowCodiHint(true);
      const timer = setTimeout(() => setShowCodiHint(false), 5000); // hide after 5s
      return () => clearTimeout(timer);
    }
  }, [collapsed]);

  const handleNavigation = (label) => {
    if (label === "Explore") navigate(`/${username}/explore`);
    else if (label === "Communities") navigate(`/${username}/communities`);
    // else if (label === "Create") navigate(`/${username}/create`);
    else if (label === "Messages") {
      setUnreadMessagesCount(0);
      navigate(`/${username}/messages`);
    }
  };

  return (
    <>
      {/* 🔹 Overlay */}
      <div
        className={`fixed inset-0 z-[9998] bg-black transition-opacity duration-300 ${
          collapsed ? "opacity-0 pointer-events-none" : "opacity-20"
        }`}
        onClick={() => setCollapsed(true)}
      />

      {/* 🔹 Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-screen w-[240px] z-[9999] 
                    bg-white shadow-lg border-r border-gray-200 
                    flex flex-col justify-between transition-transform duration-300 ${
          collapsed ? "-translate-x-full" : "translate-x-0"
        }`}
      >
        {/* Top: Header + Buttons */}
        <div>
          {/* Header */}
          <div className="flex items-center px-4 h-[60px] border-b border-gray-100 gap-2">
            <button
              onClick={() => setCollapsed(true)}
              className="text-[#0077B5] hover:text-[#005a8d] transition p-1"
            >
              <ChevronDoubleLeftIcon className="w-5 h-5 text-black" />
            </button>
            <div
              className="flex items-center cursor-pointer max-w-[160px] sm:max-w-full"
              onClick={() => navigate(`/${username}/explore`)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") navigate(`/${username}/explore`);
              }}
            >
              <img src={Logo} alt="Frontera Logo" className="w-20 object-contain" />
              <div className="text-[20px] font-bold leading-none tracking-tight text-[#0D062D] font-inter ml-[-12px] hidden sm:inline">
                Frontera
              </div>
            </div>
          </div>

          {/* Nav buttons */}
          <div className="p-4">
            <NavButtonsSection
              unreadMessagesCount={unreadMessagesCount}
              handleNavigation={handleNavigation}
            />
          </div>
        </div>

        {/* Bottom: Codi bubbler + hint */}
        <div className="pb-20 flex flex-col items-center relative">
          {/* Codi hint bubble */}
          {showCodiHint && (
            <div className="relative mb-2 flex flex-col items-center animate-fadeIn">
              {/* Main thought bubble */}
              <div className="bg-white text-gray-800 text-sm px-6 py-4 
                              rounded-3xl shadow-lg border border-gray-300 
                              text-center max-w-[220px]">
                Hey, I’m Codi!  
                <br />
                You can now create projects with me
              </div>

            </div>
          )}

          {/* CodiBubbler sits below */}
          <div className="max-w-[90%] flex justify-center">
            <CodiBubbler onClick={() => setCollapsed(true)} />
          </div>
        </div>

      </aside>

      {collapsed && shouldShowFloatingToggle && (
        <button
          onClick={() => setCollapsed(false)}
          className="fixed bottom-20 left-4 z-[9999] backdrop-blur-sm bg-white/10 border border-white/30 shadow-sm p-2 rounded-full hover:bg-white/20 transition duration-200"
          style={{
            backgroundColor: "rgba(135, 206, 250, 0.15)", 
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            pointerEvents: "auto"
          }}
        >
          <ChevronDoubleRightIcon className="w-5 h-5 text-black/70" />
        </button>
      )}

    </>
  );
};

export default NavBar;
